import { Box, Link, Stack, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import { Radios } from "../../../../../MainComponents/Radios/Radios";
import { EGInput } from "../../../../../MainComponents/Input/EGInput";
import { InvestigationButton } from "../../components/InvestigationButton";
import { DrawerContainer } from "../../components/DrawerContainer";
import { returnIsValid, useConstants } from "../../Main/useConstants";

// Funcion revisar el formulario y retornar si es valido y cuales son los errores
const validateForm = (form) => {
  const { points } = form;
  const errors = {};
  Object.entries(points).forEach(([key, point]) => {
    if (!point.value) {
      errors[key] = true;
    }
  });
  return [
    Object.entries(errors).length === 0 ? true : false,
    errors
  ];
}

export const EvaluateInterview = ({
  open,
  onClose,
  idx,
  interviews,
  handleSaveInterviews,
}) => {

  const theme = useTheme();
  const [t] = useTranslation("investigation");

  const { interviews: { pointsToEvaluateLabels, options } } = useConstants();

  const [pointsToEvaluate, setPointsToEvaluate] = useState(initPointsToEvaluate());
  const [details, setDetails] = useState("");
  const [triedToSave, setTriedToSave] = useState(false);
  const [errors, setErrors] = useState({});

  const [activeConclusionDetails, setActiveConclusionDetails] = useState(false);

  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        resetValues();
      }, 200);
    }
  }, [open]);

  useEffect(() => {
    // if (triedToSave) {
    //   const points = {};
    //   Object.entries(pointsToEvaluate).forEach(([key, point]) => {
    //     points[key] = {
    //       value: point.value,
    //       details: point.details || "",
    //     };
    //   });
    //   const [_, errors] = validateForm({ points });
    //   setErrors(errors);
    // }
  }, [pointsToEvaluate]);

  function initPointsToEvaluate() {
    const points = {};
    Object.entries(pointsToEvaluateLabels).forEach(([key, label]) => {
      points[key] = {
        value: "",
        details: false,
        label,
      };
    });
    return points;
  }

  const handleChange = (key, value) => {
    const newPoints = { ...pointsToEvaluate };
    newPoints[key].value = value;
    if (value !== "yes") {
      newPoints[key].details = false;
    }
    setPointsToEvaluate(newPoints);
  }

  const handleChangeDetails = (key, value) => {
    const newPoints = { ...pointsToEvaluate };
    newPoints[key].details = value;
    setPointsToEvaluate(newPoints);
  }

  const handleSubmit = async() => {
    
    const points = {};
    Object.entries(pointsToEvaluate).forEach(([key, point]) => {
      points[key] = {
        value: point.value,
        details: point.details || "",
      };
    });

    // const [isValid, errors] = validateForm({ points });
    // setErrors(errors);
    // setTriedToSave(true);
    // if (!isValid) {
    //   enqueueSnackbar({ variant: "error", message: t("resources.missing_required_inputs") });
    //   return;
    // };

    const evaluation = {
      points,
      details,
    }

    
    const newInterviews = _.cloneDeep(interviews);
    const newInterview = newInterviews[idx];
    newInterview.evaluation = evaluation;
    
    await handleSaveInterviews(newInterviews);
    enqueueSnackbar({ variant: "success", message: t("resources.successfully_saved") });
    resetValues();
    onClose();
  }

  const resetValues = () => {
    setPointsToEvaluate(initPointsToEvaluate());
    setDetails("");
    setActiveConclusionDetails(false);
    setErrors({});
    setTriedToSave(false);
  }

  return (
    <DrawerContainer open={open} onClose={onClose}>
      <Box padding="10px 20px 20px 20px">
        <Typography 
          fontSize={28}
          fontWeight={700}
          color="primary" 
          lineHeight={1}
        >
          {t("Evaluación de la entrevista")}
        </Typography>
        <Typography color="oxfordBlue.main" >
          {t("Califica y evalúa los resultados de la entrevista.")}
        </Typography>
        <Stack>
          {
            Object.entries(pointsToEvaluate).map(([key, point], idx) => (
              <Box key={key}>
                <hr style={{ marginTop: 11, marginBottom: 14, color: theme.palette.blueGray200.main, opacity: 1 }} />
                {
                  open &&
                  <Radios
                    value={point.value}
                    onChangue={(e) => handleChange(key, e)}
                    text={point.label}
                    options={options}
                    row
                    sxLabel={{
                      fontWeight: 600,
                      fontSize: 12,
                      ...(returnIsValid(errors[key], triedToSave) === false && { color: theme.palette.red.main, }),
                    }}
                  />
                }
                
                {
                  point.value &&
                  <Box display="flex" justifyContent={point.details !== false ? "flex-start" : "flex-end"}>
                    {
                      point.details !== false ? (
                        <EGInput
                          label="Detalles"
                          value={point.details}
                          onChange={(e) => handleChangeDetails(key, e.target.value)}
                          type="textarea"
                          multiline
                          rows={5}
                        />
                      ) : (
                        <Link
                          onClick={() => handleChangeDetails(key, "")}
                          underline="hover"
                          textAlign="end"
                        >
                          + Agregar detalles
                        </Link>
                      )
                    }
                  </Box>
                }
              </Box>
            ))
          }
        </Stack>

        <hr />

        <Box display="flex" justifyContent="flex-start">
          {
            activeConclusionDetails ? (
              <EGInput
                label={t("Detalles adicionales de evaluación")}
                value={details}
                onChange={(e) => setDetails(e.target.value)}
                type="textarea"
                multiline
                rows={5}
              />
            ) : (
              <Link
                onClick={() => setActiveConclusionDetails(true)}
                underline="hover"
                textAlign="end"
              >
                + Agregar detalles adicionales de evaluación
              </Link>
            )
          }
        </Box>

        <Stack direction={{ xs: "column", md: "row" }} justifyContent="flex-end" spacing={1} mt={2}>
          <InvestigationButton
            label={`${t("CANCELAR")}`}
            icon={false}
            size="medium"
            color="primary"
            outlined
            onClick={onClose}
          />
          <InvestigationButton 
            label={`${t("CONFIRMAR")}`}
            size="medium"
            icon={false}
            color="primary"
            outlined
            onClick={handleSubmit}
          />
        </Stack>
      </Box>
    </DrawerContainer>
  )
}